import { Switch as AntSwitch } from 'antd'
import styled from 'styled-components'
import Text from 'antd/lib/typography/Text'

export const Title = styled(Text)`
  font-size: medium;
  font-weight: bold;
`

export const Description = styled(Text)`
  color: rgba(0, 0, 0, 0.4);
`

export const Switch = styled(AntSwitch)`
  margin-right: 0.5rem;
  width: 4rem;
`
